import { EvalStatsReportFilter } from "./../admin-stats/admin-shop-eval-history/eval-stats";
import { EvalDealerFilter, EvalDealeHelperPage, ShelfRequestDTO, DefaultStatusMessage, SlugFilter } from "./../model/admin-models";
import { IdName } from "./../../../../shared/services/oem-dealer.service";
import {
  AuctionStatsRequest,
  AuctionStatsReportFilter,
  DealerInfoHelper,
  BankslipActionResponse,
  CommissionReportConsolidated,
  CommissionReportItem,
} from "./../model/comission";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  AdminDealerFilter,
  AdminDealerSummary,
  PageAdminArrematentesRequest,
  DealerDetails,
  DealerHistoryItem,
} from "../model/admin-models";
import { environment } from "@env/environment";
import { Observable, of } from "rxjs";
import { InterceptorSkipOemDealerIdHeader } from "@app-shared/guards/skip.interceptor";
import {
  ComissionReportFilter,
  ComissionReportRequest,
} from "../model/comission";
import { EvalStatsReport } from "../admin-stats/admin-shop-eval-history/eval-stats";
import { DefaultMessage } from "./user-manager.service";
import { ValueConfig } from "../model/advertisers";
import type { EvalType } from "@app-model/evaluation";
import { catchError, map } from "rxjs/operators";
import { AuctionInvoicePaidHelper } from "@app-model/dossier";
import { PageInfo } from "@app-model/application";
import { AuctionLead, AuctionLeadFilter } from "@app-model/auction-lead";

export interface DefaultStatus {
  success?: boolean;
}

export interface FileUploadStatus {
  rowNumber?: number;
  status?: string;
  success?: boolean;
  url?: string;
}

@Injectable({
  providedIn: "root",
})
export class AdminService {
  private readonly LS_SHELVES_KEY = 'aa_shelves';

  constructor(private http: HttpClient) { }

  reportCSV(filter: ComissionReportFilter): Observable<any> {
    return this.http.post(`${environment.api}/reports/commissionCSV`, filter, {
      headers: new HttpHeaders({
        Accept: "application/csv",
      }),
      responseType: "blob" as "json",
    });
  }

  dealerEventsCSV(filter: AuctionStatsReportFilter): Observable<any> {
    return this.http.post(`${environment.api}/reports/dealerEventsCSV`, filter);
  }

  downloadDealersCSV(filter: AdminDealerFilter): Observable<any> {
    return this.http.post(
      `${environment.api}/admin/dealer/reportCSV`,
      filter,
      {
        headers: new HttpHeaders({
          Accept: "application/csv",
        }),
        responseType: "blob" as "json",
      }
    );
  }

  listDealers(
    filter: AdminDealerFilter
  ): Observable<PageAdminArrematentesRequest> {
    return this.http.post(`${environment.api}/admin/dealer/search`, filter);
  }

  getDealer(id: string): Observable<DealerDetails> {
    return this.http.get(`${environment.api}/dealer/details/${id}`)
      .pipe(map((resp: DealerDetails) => {
        return resp;
      }
      )
      ) as Observable<DealerDetails>;
  }

  getDealerFullHistory(dealerId: string): Observable<DealerHistoryItem[]> {
    return this.http.get(
      `${environment.api}/admin/dealer/getFullHistory/${dealerId}`
    ) as Observable<DealerHistoryItem[]>;
  }

  getSummary(filter: AdminDealerFilter): Observable<AdminDealerSummary> {
    return this.http
      .post(`${environment.api}/admin/dealer/summary`, filter)
      .pipe(map((response: AdminDealerSummary) => response));
  }

  getDealerFilterOptions(): Observable<IdName[]> {
    return this.http
      .get<{ oemDealers: IdName[] }>(`${environment.api}/admin/dealer/filterOptions`)
      .pipe(
        map(resp => (resp && Array.isArray(resp.oemDealers) ? resp.oemDealers : []))
      );
  }

  reportComission(
    filter: ComissionReportFilter
  ): Observable<PageInfo<CommissionReportItem>> {
    return this.http.post<PageInfo<CommissionReportItem>>(`${environment.api}/reports/commission`, filter).pipe(
      map((resp: PageInfo<CommissionReportItem>) => {
        resp.data = resp.data.map((item) => {
          const commissionReportItem = Object.assign(new CommissionReportItem(), item);
          commissionReportItem.firstLatePaymentDate = item.firstLatePaymentDate ? new Date(item.firstLatePaymentDate) : null;
          commissionReportItem.latePaymentDate = item.latePaymentDate ? new Date(item.latePaymentDate) : null;
          commissionReportItem.comissionPaidAt = item.comissionPaidAt ? new Date(item.comissionPaidAt as any) : null;
          return commissionReportItem;
        });
        return resp;
      })
    );

  }

  reportCommissionConsolidated(filter: ComissionReportFilter): Observable<CommissionReportConsolidated> {
    return this.http.post<CommissionReportConsolidated>(`${environment.api}/reports/consolidatedCommission`, filter);
  }

  dealerComissionReport(filter: ComissionReportFilter, dealerId: string): Observable<ComissionReportRequest> {
    return this.http.post(`${environment.api}/reports/dealerCommission/${dealerId}`, filter);
  }

  auctionsReports(
    filter: ComissionReportFilter
  ): Observable<AuctionStatsRequest> {
    return this.http.post(`${environment.api}/reports/auctionStats`, filter);
  }

  evalStatsReports(filter: EvalStatsReportFilter): Observable<EvalStatsReport> {
    return this.http.post(`${environment.api}/reports/evalStats`, filter);
  }

  getOemDealerInfoVehicleId(id: string): Observable<DealerInfoHelper> {
    return this.http.get(
      `${environment.api}/reports/oemDealerInfoByVehicleId/${id}`
    );
  }

  saveDealer(dealer: DealerDetails): Observable<DefaultMessage> {
    return this.http.post(`${environment.api}/dealer/save`, dealer);
  }
  getDealerInfoVehicleId(id: string): Observable<DealerInfoHelper> {
    return this.http.get(
      `${environment.api}/reports/dealerInfoByVehicleId/${id}`
    );
  }

  cancelBankSlip(vehicleId, reative): Observable<BankslipActionResponse> {
    return this.http.post(
      `${environment.api}/bankslip/cancel/${vehicleId}/${reative}`,
      {}
    );
  }

  reissueBankSlip(vehicleId: string): Observable<void> {
    const headers = new HttpHeaders().set(InterceptorSkipOemDealerIdHeader, '');
    return this.http.post(
      `${environment.api}/bankslip/reissue/${vehicleId}`,
      {},
      { headers, responseType: 'text' },
    ).pipe(map(() => undefined));
  }

  updateStatusDealer(dealerId: string, inactive: boolean, reason?: string): Observable<any> {
    return this.http.patch(
      `${environment.api}/admin/dealer/status/${dealerId}?inactive=${inactive}&reason=${reason}`,
      {}
    );
  }

  denyAuthorization(dealerId: string, reason?: string): Observable<any> {
    return this.http.patch(
      `${environment.api}/admin/dealer/denyAuthorization/${dealerId}` + (reason ? `?reason=${reason}` : ''),
      {}
    );
  }

  getSuperBidStatus(dealerId: string): Observable<any> {
    return this.http.get<any>(`${environment.api}/admin/dealer/${dealerId}/superbid-status`);
  }

  postponMigration(dealerId: string, postponementReason: string, nonMigrationReason: string): Observable<any> {
    return this.http.post(
      `${environment.api}/admin/dealer/postponeMigration/${dealerId}`, {
        postponementReason: postponementReason,
        nonMigrationReason: nonMigrationReason
      }
    );
  }

  listRegions(): Observable<IdName[]> {
    return this.http.get(`${environment.api}/regional/list`) as Observable<
      IdName[]
    >;
  }

  evalDealerSearch(filter: EvalDealerFilter): Observable<EvalDealeHelperPage> {
    return this.http.post(`${environment.api}/evalDealer/search`, filter);
  }

  getPhotoTypes() {
    return this.http.get(
      `${environment.api}/oemDealer/photoTypes`
    ) as Observable<IdLabel[]>;
  }

  getMinimumFillEvaluationRules(oemDealerId: string): Observable<MinimumFillEvaluationRules> {
    return this.http.get<MinimumFillEvaluationRules>(
      `${environment.api}/evaluation/minimumFillEvaluationRules/${oemDealerId}`
    );
  }

  getOemDealerMinimumFillEvaluationRules(oemDealerId: string): Observable<MinimumFillEvaluationRules> {
    return this.http.get<MinimumFillEvaluationRules>(
      `${environment.api}/oemDealer/minimumFillEvaluationRules/${oemDealerId}`
    );
  }

  saveMinimumFillEvaluationRules(oemDealerId: string, rules: MinimumFillEvaluationRules): Observable<DefaultStatus> {
    return this.http.post<DefaultStatus>(
      `${environment.api}/oemDealer/minimumFillEvaluationRules/${oemDealerId}`,
      rules
    );
  }

  setInvoiceAsPaid(invoiceHelper: AuctionInvoicePaidHelper): Observable<DefaultMessage> {
    return this.http.post(`${environment.api}/admin/auction/${invoiceHelper.vehicleId}/setInvoiceAsPaid`, invoiceHelper);
  }

  initIntegrationDicts(integrationId: string): Observable<any> {
    return this.http.get(`${environment.api}/admin/initIntegrationDicts/${integrationId}`);
  }


  getAuctionLeads(filter: AuctionLeadFilter): Observable<PageInfo<AuctionLead>> {
    return this.http.post<PageInfo<AuctionLead>>(`${environment.api}/oemDealer/auctionLead`, filter);


  }

  saveShelf(requestDTO: ShelfRequestDTO): Observable<DefaultStatusMessage> {
    return this.http.post<DefaultStatusMessage>(
      `${environment.api}/shelf-management/save`,
      requestDTO
    )
  }

  findAllShelves(personalizationId?: string): Observable<ShelfRequestDTO[]> {
    let url = `${environment.api}/shelf-management/findAll`;
    if (personalizationId) {
      url += `?personalizationId=${personalizationId}`;
    }
    return this.http.get<ShelfRequestDTO[]>(url)
  }

  sortShelves(shelves: ShelfRequestDTO[]): Observable<DefaultStatus> {
    return this.http.put<DefaultStatus>(
      `${environment.api}/shelf-management/sort`,
       shelves 
    )
  }

  removeShelf(shelfId: string): Observable<DefaultStatus> {
    return this.http.delete<DefaultStatus>(
      `${environment.api}/shelf-management/${shelfId}/remove`
    )
  }

  uploadShelfImage(shelfId: string, file: File): Observable<FileUploadStatus> {
    const formData = new FormData();
    formData.append('file', file);
  
    return this.http.post<FileUploadStatus>(
      `${environment.api}/shelf-management/${shelfId}/upload-image`,
      formData
    )
  }

  getFilterBySlug(slugUrl: string): Observable<SlugFilter> {
    const params = new HttpParams().set('slugUrl', slugUrl.trim().toLowerCase());
    return this.http.get<SlugFilter>(`${environment.api}/open/getFilterBySlug`, { params });
  }

  getSlugFilterPageable(filter: SlugFilter): Observable<PageInfo<SlugFilter>> {
    return this.http.post<PageInfo<SlugFilter>>(
      `${environment.api}/slug-filter/getFilterBySlug`,
      filter
    );
  }

  updateSlugFilter(slugFilter: SlugFilter): Observable<DefaultStatus> {
    return this.http.put<DefaultStatus>(
      `${environment.api}/slug-filter/update`,
      slugFilter
    );
  }

  updateSlugFilterStatus(slugId: string, isDisabled: boolean): Observable<DefaultStatus> {
    return this.http.put<DefaultStatus>(
      `${environment.api}/slug-filter/status`,
      {},
      { params: { slugId, isDisabled: String(isDisabled) } }
    );
  }

  deleteSlugFilter(slugId: string): Observable<DefaultStatus> {
    return this.http.delete<DefaultStatus>(
      `${environment.api}/slug-filter/delete`,
      { params: { slugId } }
    );
  }

saveSlugFilter(slugFilter: SlugFilter): Observable<DefaultStatusMessage> {
  return this.http.post<DefaultStatusMessage>(
    `${environment.api}/slug-filter/save`,
    slugFilter
  )
}
}

export class IdLabel {
  id?: string;
  label?: string;
  selected = false;
}

export interface MinimumFillEvaluationRules {
  canEdit?: boolean;
  minimumEvaluationImages?: number;
  requiredEvaluationImageTypes?: string[];
  minimumRaioXTecnicoFilledPercent?: number;
  requiredRaioXTecnicoItems?: string[];
  requiredFieldsByType?: Partial<Record<EvalType, string[]>> | null;
}
